import React, { useState } from "react";
import { useScreenshot } from "use-react-screenshot";
import { CheckCircleOutline, EventSeat, WatchLater } from "@material-ui/icons";
import { Button, Divider } from "@material-ui/core";
import { useSelector } from "react-redux";
import PrintComponents from "react-print-components";
import QRCode from "react-qr-code";
import { useHistory } from "react-router-dom";
import ticketFooter from "../../../../../../ebusHomePics/ticket-footer.png";
import { useMediaQuery } from "react-responsive";
import queryStringParse from "../../../../../../functions/queryParam";
import { DateTimeHandler } from "./../../../../../utils/Helper";


const ReserveFourthStep = (props) => {
  const { state } = useSelector((state) => ({
    state: state.search,
  }));  

  const history = useHistory();

  const isTabletOrMobile = useMediaQuery({ maxWidth: 991 });

  const [image, takeScreenshot] = useScreenshot();
  const ref = React.createRef(null);
  const getImage = () => takeScreenshot(ref.current);

  const timeManager = (time) => {
    if (time) {
      const splittedTime = time
        .split("T")[1]
        .split(".")[0]
        .split(":");
      return `${splittedTime[0]}:${splittedTime[1]}`;
    }
  };

  const persianDateHandler = () => {
    let params=[];

    
    if (history.location.search ) {
      var search = history.location.search;
       params = queryStringParse(search);
   
   }
  //  const urlDate = params.date;
    const urlDate = history.location.pathname.split("/")[4];
    let dateOptions = {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    const persianDate = new Date(urlDate).toLocaleDateString(
      "fa-Ir",
      dateOptions
    );

    const day = persianDate.split(",")[1];
    const monthAnddate = persianDate.split(",")[0].split(" ");

    const mixed = `${day}, ${monthAnddate[2]} ${monthAnddate[1]}`;

    return mixed;
  };

  return (
    <>
      <div
        className="mx-auto w-75 border border-secondary p-17 bg-white my-10"
        style={{ height: "fit-content", width: "15cm", borderRadius: "13px" }}
      >
        <div
          className="row justify-content-center mb-5"
          style={{ color: "#6dd06d" }}
        >
          <h1>
            <b>بلیط های صادر شده</b>
          </h1>
        </div>
        <div
          className="line w-100"
          style={{
            borderBottom: "1px solid #e4e6ef",
          }}
        ></div>
        <div
          className="row justify-content-between"
          style={{ marginInline: "25px", marginBlock: "2rem" }}
        >
          <h3 className="col-12 col-md-6 my-2 " style={{ lineHeight: "20px" }}>
            {" "}
            <b>مبدا:</b>{" "}
            {state?.travelDetails?.townshipsInfo?.sourceTownshipTitle}
          </h3>
          <h3 className="col-12 col-md-6 my-2" style={{ lineHeight: "20px" }}>
            {" "}
            <b>مقصد:</b>
            {state?.travelDetails?.townshipsInfo?.destTownshipTitle}
          </h3>
        </div>
        <div
          className="line w-100"
          style={{
            borderBottom: "1px solid black",
            marginBlock: "1rem",
          }}
        ></div>
        <div
          className="row justify-content-between my-10 "
          style={{ marginInline: "25px", marginBlock: "1rem" }}
        >
          <h3 style={{ lineHeight: "20px" }} className="col-12 col-md-6 my-2">
            {" "}
            <b>تاریخ:</b> {persianDateHandler()}
          </h3>
          <h3 className="col-12 col-md-6 my-2" style={{ lineHeight: "20px" }}>
            <b>ساعت حرکت:</b>{" "}
            {timeManager(
              state?.travelDetails?.directionInfo?.departureDatetime
            )}
          </h3>
        </div>
        <div
          className="line w-100"
          style={{
            borderBottom: "1px solid black",
            marginBlock: "1rem",
          }}
        ></div>
        <div
          className="row mt-2 mb-5"
          style={{ marginRight: "25px", marginLeft: "12px" }}
        >
          <div
            className="col-12 col-lg-9"
            style={{ paddingBlock: "2rem", lineHeight: "20px" }}
          >
            <h3 style={{ marginBlock: "1rem" }}>
              <b>شماره صندلی:</b>{" "}
              {state.fullSeats.length !== 0
                ? state.fullSeats.map((el, idx) => {
                    if (idx === state.fullSeats.length - 1) {
                      return `${el.seatNumber}  `;
                    } else {
                      return `${el.seatNumber}, `;
                    }
                  })
                : null}
            </h3>
            <div
              className="line w-100"
              style={{
                borderBottom: "1px solid black",
                marginBlock: "1rem",
              }}
            ></div>

            <h3 style={{ marginTop: "3rem", lineHeight: "20px" }}>
              <b>نام مسافر/مسافرین:</b>
              <br />
              {state.fullSeats.map((el, idx) => {
                if (idx === state.fullSeats.length - 1) {
                  return `${el.firstName} ${el.lastName} `;
                } else {
                  return `${el.firstName} ${el.lastName} , `;
                }
              })}
            </h3>
          </div>
          <div
            className="col-12 col-lg-3 w-100"
            style={{ paddingBlock: "2rem" }}
          >
            <QRCode
              value={state?.ticketDetails?.qrCode}
              className="w-100"
              size={isTabletOrMobile ? "120" : "150"}
            />
          </div>
        </div>
        <img src={ticketFooter} className="w-100" />
        <div className="row mt-10 ">
          <div className="col-12 col-md-6 my-2 p-1" style={{ height: "4rem" }}>
            <Button
              className="w-100 h-100"
              style={{
                border: "0.5px solid #6dd06d",
                borderRadius: "13px",
              }}
              onClick={() => {
                history.push("/");
              }}
            >
              <h6
                className="mx-auto my-auto"
                style={{
                  color: "#6dd06d",
                }}
              >
                {" "}
                بازگشت به صفحه اصلی
              </h6>
            </Button>
          </div>
          <div className="col-12 col-md-6 my-2 p-1" style={{ height: "4rem" }}>
            <PrintComponents
              trigger={
                <Button
                  className="w-100 h-100"
                  style={{
                    backgroundColor: "#6dd06d",
                    border: "0.5px solid white",
                    borderRadius: "13px",
                  }}
                >
                  <h6 className="ms-auto my-auto text-white"> چاپ بلیط</h6>
                </Button>
              }
            >
              <div
              className="mx-auto w-75 border border-dark px-7"
              style={{ height: "20cm", width: "15cm" }}
              >
              <div
                className="row justify-content-between"
                style={{ marginInline: "25px", marginBlock: "3rem 1.5rem" }}
              >
                <h1>
                  {" "}
                  <b>مبدا:</b> {props.data?.sourceTownship}
                </h1>
                <h1>
                  {" "}
                  <b>مقصد:</b>
                  {props.data?.destTownship}
                </h1>
              </div>
              <div
                className="line w-100"
                style={{
                  borderBottom: "4px solid black",
                  marginBlock: "2rem",
                }}
              ></div>
              <div
                className="row justify-content-between my-5 "
                style={{ marginInline: "25px", marginBlock: "3rem 1.5rem" }}
              >
                <h1>
                  <b>تاریخ:</b>
                  <span style={{ marginRight: 5 }}>
                    {
                      DateTimeHandler(props.data?.departureDatetime).date
                    }
                  </span>
                </h1>
                <h1>
                  <b>ساعت حرکت:</b>
                  <span style={{ marginRight: 5 }}>
                    {
                      DateTimeHandler(props.data?.departureDatetime).time
                    }
                  </span>
                </h1>
              </div>
              <div
                className="line w-100"
                style={{
                  borderBottom: "4px solid black",
                  marginBlock: "2rem",
                }}
              ></div>
              <div
                className="row mt-2 mb-5"
                style={{ marginRight: "25px", marginLeft: "12px" }}
              >
                <div className="col-6" style={{ paddingBlock: "2rem" }}></div>
                <div className="col-6 w-100" style={{ paddingBlock: "2rem" }}>
                  {props.data.qrCode ? (
                    <QRCode
                      value={props.data.qrCode}
                      className="w-100"
                      style={{ height: "5rem" }}
                    />
                  ) : null}
                </div>
              </div>
              <img src={ticketFooter} className="w-100" />
            </div>
            </PrintComponents>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReserveFourthStep;
